import { updateItems } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              最新动态
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-500">
              海角网平台公告、功能更新与社区快讯
            </p>
          </div>
          <div className="relative">
            <div className="absolute left-4 top-2 bottom-2 w-px bg-background-300"></div>
            <div className="space-y-5">
              {updateItems.map((item, idx) => (
                <div key={item.id} className="flex gap-4 items-start relative">
                  <div className={`w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0 z-10 ${
                    idx === 0 ? 'bg-primary-500 text-white' :
                    idx === 1 ? 'bg-accent-500 text-white' :
                    'bg-background-200 text-foreground-500'
                  }`}>
                    <i className={`text-sm ${idx < 2 ? 'ri-flag-line' : 'ri-record-circle-line'}`}></i>
                  </div>
                  <div className="flex-1 min-w-0 pb-5 border-b border-background-200/60">
                    <div className="flex flex-wrap items-center gap-2 mb-1">
                      <span className="text-xs text-foreground-400">{item.date}</span>
                      <span className={`text-xs font-medium px-2 py-0.5 rounded-full ${
                        item.tag === '平台公告' ? 'bg-primary-100 text-primary-700' :
                        item.tag === '功能更新' ? 'bg-accent-100 text-accent-700' :
                        item.tag === '内容上新' ? 'bg-secondary-100 text-secondary-700' :
                        'bg-foreground-100 text-foreground-600'
                      }`}>
                        {item.tag}
                      </span>
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed">
                      {item.title}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}